<template>
  <el-upload
    drag
    action=""
    :file-list="stored"
    :auto-upload="false"
    :on-change="fileChangeHandler"
    :on-preview="download"
    ref="files"
  >
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
    <div v-if="tip" class="el-upload__tip" slot="tip">{{ tip }}</div>
  </el-upload>
</template>

<script>
import filesize from 'filesize';
import fileModel from './file-model';

export default {
  name: 'app-file-upload',

  props: {
    stored: {
      type: Array,
      default() {
        return [];
      },
    },
    formats: Array,
    size: Number,
    max: Number,
  },

  computed: {
    tip() {
      const hasFormats =
        this.formats && this.formats.length;
      const hasSize = this.size;

      if (!hasFormats && !hasSize) {
        return null;
      }

      if (!hasFormats && hasSize) {
        return `files with a size less than ${filesize(
          this.size,
        )}`;
      }

      if (hasFormats && !hasSize) {
        return `${this.formats.join('/')} files`;
      }

      return `${this.formats.join(
        '/',
      )} files with a size less than ${filesize(
        this.size,
      )}`;
    },

    data() {
      return this.$refs.files.uploadFiles;
    },
  },

  methods: {
    download(file) {
      window.open(file.url, '_blank');
    },

    fileChangeHandler(file, files) {
      return fileModel.changeHandler(
        file,
        files,
        this.max,
        this.size,
        this.formats,
      );
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/shared/file/file-upload.vue?0d584c00